import "./AdvertLarge.scss";
const AdvertLarge = () => {
  return (
    <div className="advertLarge">
      <div className="advertLargeWrapper">
        <a>
          <img src="assets/ad-970x90.jpg" alt="Advertisement" />
        </a>
      </div>
    </div>
  );
};
export default AdvertLarge;
